export enum ErrorCodes {
  InvalidReportId = 4000000,
  InvalidSessionId = 4010001,
  SessionKicked = 4010002,
  UserNotActive = 4010004, // subscriber inactive or suspend
  OwnerNotActive = 4010005,
  InvalidIpAddress = 4030002,
  ConcurrentSessionLimit = 4030001,
  ReportNotFound = 4040000,
  InvalidEmailOrReportKey = 4010006,
  PermissionDenied = 10000
}

// Errors that might be returned from every single API.
export const UNIVERSAL_ERROR_CODES = [
  ErrorCodes.InvalidReportId,
  ErrorCodes.InvalidSessionId,
  ErrorCodes.SessionKicked,
  ErrorCodes.OwnerNotActive,
  ErrorCodes.InvalidIpAddress,
  ErrorCodes.ConcurrentSessionLimit,
  ErrorCodes.ReportNotFound
]
